<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <app-card-actions
    class="daily-report-contents-wrapper mb-6"
    action-collapse
  >
    <template #title>
      プレイヤー
    </template>

    <v-card-text v-if="loading || error || aggregations.length === 0">
      <v-skeleton-loader
        v-if="loading"
        type="table"
      />
      <v-alert
        v-else-if="error"
        type="error"
      >
        {{ error }}
      </v-alert>
      <v-alert
        v-else
        type="info"
      >
        プレイヤーが設定されていません
      </v-alert>
    </v-card-text>

    <v-card-text v-else>
      <!-- 下位タブ: 集計表別 -->
      <v-tabs
        v-model="aggregationTab"
        show-arrows
        grow
        height="58"
      >
        <v-tab
          v-for="agg in aggregations"
          :key="agg.id"
        >
          {{ agg.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="aggregationTab"
        touchless
        style="background: transparent"
      >
        <v-tab-item
          v-for="agg in aggregations"
          :key="agg.id"
        >
          <read-only-aggregation-table :aggregation="toAggregationProp(agg)" />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </app-card-actions>
</template>

<script>
import {
  ref,
  watch,
  onMounted,
} from '@vue/composition-api'
import AppCardActions from '@core/components/app-card-actions/AppCardActions.vue'
import ReadOnlyAggregationTable from '@/views/v2-temp/eod-closing/components/ReadOnlyAggregationTable.vue'
import EodClosingUserAggregationApi from '@/api/v2/eod-report/EodClosingUserAggregation'

export default {
  components: {
    AppCardActions,
    ReadOnlyAggregationTable,
  },
  props: {
    date: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const loading = ref(false)
    const error = ref(null)
    const aggregations = ref([])
    const aggregationTab = ref(0)

    // APIレスポンスを ReadOnlyAggregationTable が期待する aggregation prop の形式に変換
    const toAggregationProp = agg => ({
      attributes: {
        id: agg.id,
        name: agg.name,
        description: null,
        type: 'EodClosingUserAggregation',
        businessRules: {
          data: agg.businessRules.map(br => ({
            id: String(br.id),
            type: 'business_rule',
            attributes: {
              id: br.id,
              name: br.name,
              description: null,
            },
          })),
        },
        contexts: {
          data: agg.users.map(user => ({
            attributes: {
              contextType: 'User',
              id: user.userId,
              name: user.name,
              results: {
                data: user.results.map(r => ({
                  attributes: {
                    businessRuleId: r.businessRuleId,
                    businessRuleResultId: r.value != null && r.value !== '' ? -1 : null,
                    value: r.value,
                    dependentResources: null,
                    dependentBusinessRuleIds: [],
                    editable: false,
                  },
                })),
              },
            },
          })),
        },
      },
    })

    const fetchAggregations = async () => {
      if (!props.date) return
      loading.value = true
      error.value = null
      try {
        const res = await EodClosingUserAggregationApi.getAggregations(props.date)
        aggregations.value = res.data || []
      } catch (e) {
        error.value = 'データの取得に失敗しました'
      } finally {
        loading.value = false
      }
    }

    watch(() => props.date, () => {
      fetchAggregations()
    })

    onMounted(() => {
      fetchAggregations()
    })

    return {
      loading,
      error,
      aggregations,
      aggregationTab,
      toAggregationProp,
    }
  },
}
</script>
